export const Vehicles = [
  {
    make: "tesla",
    model: "model-y",
    paintColor: "pspc0004sspc0256",
    name: "TESLA MODEL Y",
    variant: "Rear-Wheel Drive",
    engineDesc: "ELECTRIC",
    transmission: "REDUCTION GEAR",
    body: "SUV",
    fuelConsumption: "0",
    range: "510km",
    weeklyPrice: "212",
    cardColor: "green",
  },
  {
    make: "tesla",
    model: "model-3",
    paintColor: "pspc0256",
    name: "TESLA MODEL 3",
    variant: "Rear-Wheel Drive",
    engineDesc: "ELECTRIC",
    transmission: "REDUCTION GEAR",
    body: "SEDAN",
    fuelConsumption: "0",
    range: "629km",
    weeklyPrice: "209",
    cardColor: "green",
  },
  {
    make: "mg",
    model: "mg4",
    paintColor: "pspc0256sspc0004",
    name: "MG MG4",
    variant: "Excite 51 125kW",
    engineDesc: "ELECTRIC",
    transmission: "REDUCTION GEAR",
    body: "HATCHBACK",
    range: "405km",
    fuelConsumption: "0",
    weeklyPrice: "154",
    cardColor: "green",
  },
  {
    make: "byd",
    model: "seal",
    paintColor: "pspc0058",
    name: "BYD SEAL",
    variant: "Dynamic",
    engineDesc: "ELECTRIC",
    transmission: "REDUCTION GEAR",
    body: "SEDAN",
    fuelConsumption: "0",
    range: "510km",
    weeklyPrice: "169",
    cardColor: "green",
  },
  {
    make: "kia",
    model: "ev5",
    paintColor: "pspc0297",
    name: "KIA EV5",
    variant: "Air Standard Range",
    engineDesc: "ELECTRIC",
    transmission: "REDUCTION GEAR",
    body: "SUV",
    fuelConsumption: "0",
    range: "400KM",
    weeklyPrice: "208",
    cardColor: "green",
  },
  {
    make: "polestar",
    model: "4",
    paintColor: "pspc0041",
    name: "Polestar 4",
    variant: "Long range Single motor",
    engineDesc: "ELECTRIC",
    transmission: "REDUCTION GEAR",
    body: "SUV",
    fuelConsumption: "0",
    range: "-",
    weeklyPrice: "266",
    cardColor: "green",
  },
  {
    make: "Geely",
    model: "ex5",
    paintColor: "pspc0004sspc0146",
    name: "Geely EX5",
    variant: "Complete",
    engineDesc: "ELECTRIC",
    transmission: "REDUCTION GEAR",
    body: "SUV",
    fuelConsumption: "0",
    range: "-",
    weeklyPrice: "165",
    cardColor: "green",
  },
  {
    make: "bmw",
    model: "ix1",
    paintColor: "pspc0004sspc0256",
    name: "BMW iX1",
    variant: "eDrive20 xLine",
    engineDesc: "Electric",
    transmission: "AUTOMATIC",
    body: "SUV",
    fuelConsumption: "0",
    range: "464KM",
    weeklyPrice: "277",
    cardColor: "green",
  },
  {
    make: "xpeng",
    model: "g6",
    paintColor: "pspc0256",
    name: "XPeng G6",
    variant: "Standard Range",
    engineDesc: "Electric",
    transmission: "AUTOMATIC",
    body: "SUV",
    fuelConsumption: "0",
    range: "-",
    weeklyPrice: "202",
    cardColor: "green",
  },
  {
    make: "byd",
    model: "sealion-07",
    paintColor: "pspc0004sspc0146",
    name: "BYD SEALION 7",
    variant: "Premium",
    engineDesc: "Electric",
    transmission: "AUTOMATIC",
    body: "SUV",
    fuelConsumption: "0",
    range: "567KM",
    weeklyPrice: "193",
    cardColor: "green",
  },
];